export type CampaignInforType = {
  id: string,
  campaignId: string,
  campaignName: string

  // only for state
  startDate?: Date | null;
  endDate?: Date | null;
};

export type RulesListItem = {
  _id: string;
  ruleId: string;
  campaignFrom: CampaignInforType;
  campaignTo: CampaignInforType;
  status: RulesStatus;
  createdAt: Date;
  lastUpdatedAt: Date;
  createdBy: string;
  lastUpdatedBy: string;
  publishedAt: Date;
  stoppedAt: Date;
};

export type RulesLeadListItem = {
  _id: string;
  alias: string;
  agentCodeFrom: string;
  agentCodeTo: string;
  status: RulesDistributionStatus;
  leadDate: Date;
  leadIdOld: string;
  leadIdNew: string;
  createdAt: Date;
  updatedAt: Date;
};

export type RulesDetail = {
  id?: string;
  leadDateFrom: Date;
  leadDateTo: Date;
  leadReferSource: string | null;
  campaignFrom: CampaignInforType | null;
  campaignTo: CampaignInforType | null;
  leadStatusList?: { days: number; status: string }[]; // only for status rule
  estimatedTotalLeadBeforePublish?: number;
};

export type RulesDetailFormState = {
  id?: string;
  leadDate: Date[];
  leadReferSource: string;
  campaignFrom: CampaignInforType | null;
  campaignTo: CampaignInforType | null;
  leadStatusList: { days: number; status: string }[]; // only for status rule
};

export enum FormMode {
  CREATE = "create",
  EDIT = "edit",
  VIEW = "view",
}

export enum CampaignType {
  campaignFrom = 'campaignFrom',
  campaignTo = 'campaignTo',
}

export enum RulesType {
  statusRule = 'status-rule',
  terminatedAgentRule = 'terminated-agent-rule',
}

export enum RulesStatus {
  active = 'Active',
  stopped = 'Stopped',
}

export enum RulesDistributionStatus {
  queue = 'Queue',
  distributing = 'Distributing',
  distributed = 'Distributed',
  failed = 'Failed',
}

export type CampaignFilterType = {
  campaignType: CampaignType;
  leadDateFrom?: Date | null;
  leadDateTo?: Date | null;
};
